import { Hero, Problem, Education, LocalOK } from "@/components/home/HomeTop";
import { WhatWeTest, Difference, SoftenerVsFilter, Pricing } from "@/components/home/HomeMid";
import { Process, Testimonials, Faq, FinalCta } from "@/components/home/HomeBottom";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Problem />
      <Education />
      <LocalOK />
      <WhatWeTest />
      <Difference />
      <SoftenerVsFilter />
      <Pricing />
      <Process />
      <Testimonials />
      <Faq />
      <FinalCta />
    </main>
  );
}
